import { lazy } from 'react';

export function safeLazy(importFactory) {
    return lazy(async () => {
        try {
            return await importFactory();
        } catch (error) {
            // Pinpoint asset loading errors
            const isChunkLoadError =
                error?.message?.includes("Failed to fetch dynamically imported module") ||
                error?.stack?.includes("Failed to fetch dynamically imported module") ||
                (error instanceof TypeError && error.message?.includes("dynamic"));

            if (isChunkLoadError) {
 
                // Append an explicit cache-busting flag to force an asset pull from the host
                window.location.href =
                    window.location.pathname +
                    window.location.search +
                    (window.location.search ? '&' : '?') +
                    'reload_ts=' + Date.now();

                // Return an unresolving promise to pause rendering during the hard navigation
                return new Promise(() => { });
            }

            // Let other unexpected runtime exceptions pass through to your handlers
            throw error;
        }
    });
}
